// Removes HTML (tags, <script>/<style> contents, HTML comments)
// and normalizes whitespace – similar to Liquid | strip_html
export function stripHtml(input) {
  if (input === null) return '';
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.body.textContent || '';
}

// Truncate text by word count – similar to Liquid | truncatewords
// endStr is the suffix (Liquid defaults to "...")
export function truncateWords(text, wordLimit, endStr = '…') {
  if (text === null) return '';
  if (!Number.isFinite(wordLimit) || wordLimit <= 0) return '';
  const words = String(text).trim().split(/\s+/).filter(Boolean);
  if (words.length <= wordLimit) return words.join(' ');
  return words.slice(0, wordLimit).join(' ') + endStr;
}
